import Cookies from 'js-cookie'

const TokenKey = 'test-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
    Cookies.remove('ruoyiIds');
    Cookies.remove('userInfo')
  return Cookies.remove(TokenKey)
}
